export default __webpack_public_path__ + "images/desktop-start1-25a87d.svg";